import React from "react";
import { useWindupString } from "windups";
import { Button } from "@kui/react";
import { classNames } from "components/utils";
import { useHistory } from "react-router";

interface DeployingProps {
  workspaceId?: string;
  activeOrgId?: string;
}

export const Deploying: React.FC<DeployingProps> = ({
  workspaceId,
  activeOrgId,
}) => {
  const history = useHistory();
  const [text] = useWindupString("Launchable is now deploying...");

  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-row justify-center items-end">
          <p
            className={classNames(
              "truncate",
              "text-sm text-highlight font-mono justify-center min-w-[255px]"
            )}
          >
            {text}
          </p>
          <Button
            className="pulse-ready-button ml-5"
            onClick={() => {
              history.push(
                `/org/${activeOrgId}/environments/${workspaceId}#Container`
              );
            }}
            disabled={!workspaceId}
          >
            Go to Instance Page
          </Button>
        </div>
        <div className="flex flex col justify-center mt-3">
          <p className="text-sm text-gray-700 dark:text-secondary">
            For additional options, logs, and access click the button above
          </p>
        </div>
      </div>
    </>
  );
};
